import axiosPlataformaClient from '../../plugins/axios.plataforma.plugin';

export default {
  getAll({ filter, sortBy, order, groupSetId }) {
    return axiosPlataformaClient.custAxios().get(`academic/groupset/${groupSetId}/groups?filter=${filter || ''}&sortBy=${sortBy || ''}&order=${order || ''}`);
  },
  delete({ groupSetId, groupId }) {
    return axiosPlataformaClient.custAxios().delete(`academic/groupset/${groupSetId}/groups/${groupId}`);
  },
  getParticipants({ groupSetId, groupId }) {
    return axiosPlataformaClient.custAxios().get(`academic/groupset/${groupSetId}/groups/${groupId}/participants`);
  },
  enrollToGroup({ groupSetId, groupId, enrollmentIds }) {
    return axiosPlataformaClient.custAxios().post(`academic/groupset/${groupSetId}/groups/${groupId}/participants`, enrollmentIds);
  },
  removeParticipant({ groupSetId, groupId, enrollmentId }) {
    return axiosPlataformaClient.custAxios().delete(`academic/groupset/${groupSetId}/groups/${groupId}/participants/${enrollmentId}`);
  },
  getAllDisciplineGroupsets(academicMainId) {
    return axiosPlataformaClient.custAxios().get(`academic/academics-main/${academicMainId}/group-sets`);
  },
  getGroupSet({ academicMainId, groupSetId }) {
    return axiosPlataformaClient.custAxios().get(`/academic/academics-main/${academicMainId}/group-sets/${groupSetId}`);
  },
  studentAutoJoinGroup({ groupSetId, groupId, enrollmentId }) {
    return axiosPlataformaClient.custAxios().put(`academic/groupset/${groupSetId}/groups/${groupId}/participants/${enrollmentId}`);
  },
  deleteDelivery({ mainGroupId, topicId, attemptNumber, topicType }) {
    return axiosPlataformaClient.custAxios().delete(`/content/group/${mainGroupId}/topic/${topicId}/attempt/${attemptNumber}?type=${topicType}`);
  },
  removeParticipantFromGroup({ groupSetId, groupId, enrollmentId, groupChangeConfiguration }) {
    return axiosPlataformaClient.custAxios().delete(`academic/groupset/${groupSetId}/groups/${groupId}/participants/${enrollmentId}?groupChangeConfiguration=${groupChangeConfiguration}`);
  }
};
